import { render, staticRenderFns } from "./BookingPositionNativeCreate.vue?vue&type=template&id=5add2fc7&"
import script from "./BookingPositionNativeCreate.vue?vue&type=script&lang=js&"
export * from "./BookingPositionNativeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports